import { createContext, useContext, useEffect, useState } from "react";
import { api } from "@/lib/api";

const AuthCtx = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null); // null = checking, false = guest

  useEffect(() => {
    if (window.location.hash?.includes("session_id=")) return setUser(false);
    if (!localStorage.getItem("faunny_token")) return setUser(false);
    api.get("/auth/me").then((r) => setUser(r.data)).catch(() => {
      localStorage.removeItem("faunny_token");
      setUser(false);
    });
  }, []);

  const login = async (email, password) => {
    const { data } = await api.post("/auth/login", { email, password });
    localStorage.setItem("faunny_token", data.token);
    setUser(data.user);
    return data.user;
  };
  const register = async (name, email, password) => {
    const { data } = await api.post("/auth/register", { name, email, password });
    localStorage.setItem("faunny_token", data.token);
    setUser(data.user);
    return data.user;
  };
  const loginWithToken = (data) => {
    localStorage.setItem("faunny_token", data.token);
    setUser(data.user);
    return data.user;
  };
  const logout = () => {
    localStorage.removeItem("faunny_token");
    setUser(false);
  };

  return <AuthCtx.Provider value={{ user, setUser, login, register, logout, loginWithToken }}>{children}</AuthCtx.Provider>;
}

export const useAuth = () => useContext(AuthCtx);
